export default __webpack_public_path__ + "static/media/koho_next arrow white.2c087018.svg";